import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

interface CartState {
  items: any[];
  cartQuantity: number;
}

const initialState: CartState = {
  items: [],
  cartQuantity: 0,
};

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action: PayloadAction<any>) => {
      const exists = state.items?.some(
        (item: any) => item?.product_id === action.payload?.product_id,
      );
      if (!exists) {
        state.items.push(action.payload);
      }
    },

    removeFromCart: (state, action: PayloadAction<number>) => {
      state.items = state?.items?.filter(
        (item: any) => item?.product_id !== action.payload,
      );
    },
    setCartItems: (state, action: PayloadAction<any[]>) => {
      state.items = action.payload;
    },
    updateCartQuantity: (state, action: PayloadAction<number>) => {
      state.cartQuantity = action?.payload;
    },
    resetCart: (state) => {
      state.items = [];
      state.cartQuantity = 0;
    },
  },
});

export const { updateCartQuantity } = cartSlice.actions;
export const { resetCart } = cartSlice.actions;

export const { addToCart } = cartSlice.actions;
export const { removeFromCart } = cartSlice.actions;
export const { setCartItems } = cartSlice.actions;

export const selectItems = (state: RootState) => state.cart.items;

export default cartSlice.reducer;
